import axios from '@/axios.js'

const state = () => ({
  akuns: [],
  akungroups: [],
  akunmodal: [],
  akuntaxonomy: []
})

const mutations = {
  SET_AKUNS (state, payload) {
    state.akuns = payload
  },
  SET_AKUN_GROUPS (state, payload) {
    state.akungroups = payload
  },
  SET_AKUN_MODAL (state, payload) {
    state.akunmodal = payload
  },
  ADD_AKUN (state, item) {
    state.akuns.unshift(item)
    if (state.akungroups.length > 0) {
      state.akungroups.push(item)
    }
  },
  UPDATE_AKUN (state, akun) {
    const akunIndex = state.akuns.findIndex((p) => p.id === akun.id)
    Object.assign(state.akuns[akunIndex], akun)
  },
  REMOVE_AKUN (state, itemId) {
    const ItemIndex = state.akuns.findIndex((p) => p.id === itemId)
    state.akuns.splice(ItemIndex, 1)
  },

  SET_AKUNTAXONOMY (state, payload) {
    state.akuns = payload.akunlist
    state.akuntaxonomy = payload.akuntaxonomy
  },
  ADD_AKUNTAXONOMY (state, item) {
    state.akuntaxonomy.unshift(item)
    const ItemIndex = state.akuns.findIndex((p) => p.id === item.id)
    state.akuns.splice(ItemIndex, 1)
  },
  REMOVE_AKUNTAXONOMY (state, item) {
    state.akuns.unshift(item)
    const ItemIndex = state.akuntaxonomy.findIndex((p) => p.id === item.id)
    state.akuntaxonomy.splice(ItemIndex, 1)
  },
}

const actions = {
  fetchAkun ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list/akun`)
        .then((response) => {
          commit('SET_AKUNS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAkunSort ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list-sort/akun/ASC`)
        .then((response) => {
          commit('SET_AKUNS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAkunGroups ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list-group/akun`)
        .then((response) => {
          commit('SET_AKUNS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAkunGroup ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list-group-meta/akun/${slug}`)
        .then((response) => {
          commit('SET_AKUN_GROUPS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAkunModal ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list-group-modal`)
        .then((response) => {
          commit('SET_AKUN_MODAL', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addAkun ({ commit }, akun ) {
    return new Promise((resolve, reject) => {
      axios.post('/term-add', akun)
        .then((response) => {
          commit('ADD_AKUN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateAkun ({ commit }, akun) {
    return new Promise((resolve, reject) => {
      axios.post(`/term-update/${akun.id}`, akun)
        .then((response) => {
            commit('UPDATE_AKUN', response.data.data)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeAkun ({ commit }, akun) {
    return new Promise((resolve, reject) => {
      axios.delete(`/term-delete/${akun.id}`)
        .then((response) => {
            commit('REMOVE_AKUN', akun.id)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchAkunTaxonomy ({ commit }, kategori) {
    return new Promise((resolve, reject) => {
      axios.get(`/akuntaxonomy-list/akun/${kategori}`)
        .then((response) => {
          commit('SET_AKUNTAXONOMY', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addAkunTaxonomy ({ commit }, taxonomy ) {
    return new Promise((resolve, reject) => {
      axios.post('/taxonomy-add', taxonomy)
        .then((response) => {
          commit('ADD_AKUNTAXONOMY', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeAkunTaxonomy ({ commit }, taxonomy) {
    return new Promise((resolve, reject) => {
      axios.post('/akuntaxonomy-delete', taxonomy)
        .then((response) => {
          commit('REMOVE_AKUNTAXONOMY', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}